<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header
        :entity="$entitiesName.Vat"
        :edit="edit"
        :save="save"
        :cancel="cancel"
        :remove="remove"
      >
        <h1 class="title">
          <breadcrumb location="/vats" :text="$t('entities.vat')"></breadcrumb>
          {{ vat.name }}
        </h1>
      </page-header>
      <div class="panel">
        <div class="panel-heading has-background-primary">
          <span>{{ $t("common.information") }}</span>
        </div>
        <div class="panel-block is-block no-border">
          <div class="columns" v-if="vat.id">
            <div class="column is-half">
              <text-field
                cy-data="vat-name"
                :label="$t('common.name')"
                v-model="vat.name"
                required
              />
              <numeric-field
                cy-data="vat-amount"
                :label="$t('vats.amount')"
                v-model="vat.amount"
                required
                min="0"
                step="0.01"
                unit="%"
              />
              <checkbox-field
                cy-data="vat-reversed"
                :label="$t('markets.vatTypes.reverseCharge')"
                v-model="vat.reversedCharge"
              />
              <text-field
                cy-data="vat-oracle"
                :label="$t('common.oracleCode')"
                v-model="vat.oracleCode"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Vat",
  props: ["id"],
  data() {
    return {
      vat: {
        id: null,
        name: null,
        amount: null,
        reversedCharge: false,
        oracleCode: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      editMode: "states/isEdition",
    }),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      return axios.get(`/vat/${this.id}`).then((r) => {
        this.vat = r.data;
      });
    },
    remove() {
      return this.$awn.confirm(this.$t("expressions.delete"), () =>
        axios.delete(`/vat/${this.id}`).then((response) => {
          if (response.data && response.data.success) {
            this.$router.replace("/vats");
          }
        })
      );
    },
    save() {
      return this.$validator.validateAll().then((result) => {
        if (result) {
          const body = {
            name: this.vat.name,
            amount: this.vat.amount,
            reversedCharge: !!this.vat.reversedCharge,
            oracleCode: this.vat.oracleCode || null,
          };
          return axios.put(`/vat/${this.id}`, body).then((response) => {
            if (response.data && response.data.success) {
              this.cancel();
            }
          });
        }
        return Promise.resolve();
      });
    },
    edit() {
      this.$store.dispatch("states/setEdition", true);
    },
    cancel() {
      return this.fetchData().then(() => {
        this.$store.dispatch("states/setEdition", false);
      });
    },
  },
};
</script>
